export default "/assets/images/pug.7048e61745d6db39.mp4";